module.exports = __webpack_public_path__ + "static/media/pancakes.5227b607.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/components/GetDish/pancakes.jpg
// module id = 342
// module chunks = 0